import React, { Component } from 'react'
import { Modal, Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import Button from '../comun/button/Button'
import ButtonChangeRecord from '../comun/button/ButtonChangeRecord'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputText from '../comun/form/InputText'
import InputDatePicker from '../comun/form/InputDatePicker'
import InputTextArea from '../comun/form/InputTextArea'
import InputSelect from '../comun/form/InputSelect'
import InputNumerical from '../comun/form/InputNumerical'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import {tipoAnalisisExtraccion as tipoAnalisisExtraccionConstants} from '../../constants/analisis'
import {tipoControlSeguimiento, tipoControlSeguimiento as tipoControlSeguimientoConstants} from '../../constants/seguimiento'
import {permisos as permisosConstant} from '../../constants/permisos'

class ModalFormSeguimiento extends Component {
  constructor () {
    super()
    this.state = {
      tipoAnalisisSeleccionado: null,
      archivoAnalisis: null,
      datosProcesar: null
    }
    this.handleChangeTipoAnalisis = this.handleChangeTipoAnalisis.bind(this)
    this.handleChangeTipoControl = this.handleChangeTipoControl.bind(this)
    this.abrirMagavision = this.abrirMagavision.bind(this)
    this.obtenerYGuardarResultadoSistemaAnalisisSeguimiento = this.obtenerYGuardarResultadoSistemaAnalisisSeguimiento.bind(this)
    this.guardarSeguimiento = this.guardarSeguimiento.bind(this)
  }

  guardarSeguimiento (values) {
    this.props.actions.guardarModalFormSeguimiento({
      ...values,
      idAnalisis: this.props.idAnalisis || this.props.data.idAnalisis || this.props.match.params.idAnalisisExtraccion || null,
      idPool: this.props.idPool || this.props.data.idPool || this.props.match.params.idPoolExtraccion || null
    })
  }

  handleChangeTipoAnalisis (tipoAnalisisSeleccionado) {
    this.setState({tipoAnalisisSeleccionado: tipoAnalisisSeleccionado ? tipoAnalisisSeleccionado.value : null})
  }

  handleChangeTipoControl (tipoControlSeleccionado) {
    this.setState({tipoControlSeleccionado: tipoControlSeleccionado ? tipoControlSeleccionado.value : null})
  }

  abrirMagavision(tipoAnalisis) {
    let isPool = ((this.props.idPool || this.props.data.idPool || this.props.match.params.idPoolExtraccion) != null)
    this.props.actions.abrirMagavision(tipoAnalisis, true, isPool)
  }

  obtenerYGuardarResultadoSistemaAnalisisSeguimiento() {
    this.props.actions.obtenerYGuardarResultadoSistemaAnalisisSeguimiento(this.state.tipoAnalisisSeleccionado)
  }

  componentDidMount () {
    if (this.props.tipoAnalisisPredeterminado) {
      let tipoAnalisisPredeterminado = this.props.combos.comboTipoAnalisisExtraccion.find((tipoAnalisisExtraccionItem) => {
        return tipoAnalisisExtraccionItem.value === this.props.tipoAnalisisPredeterminado
      })
      tipoAnalisisPredeterminado = {value: tipoAnalisisPredeterminado.value, label: this.props.t(`COMUN.COMBOS.${tipoAnalisisPredeterminado.label}`)}
      this.setState({tipoAnalisisSeleccionado: tipoAnalisisPredeterminado.value})
      this.props.change('tipoAnalisis', tipoAnalisisPredeterminado)
    }
    if(this.props.tipoControlSeleccionado) {
      this.setState({tipoControlSeleccionado: this.props.tipoControlSeleccionado})
    }
    this.props.change('apto', true)
    this.props.actions.comboOperarioPredeterminado()
  }

  componentDidUpdate (prevProps) {
    if (this.props.tipoAnalisisPredeterminado !== prevProps.tipoAnalisisPredeterminado) {
      let tipoAnalisisPredeterminado = this.props.tipoAnalisisPredeterminado
      if (this.props.tipoAnalisisPredeterminado) {
        tipoAnalisisPredeterminado = this.props.combos.comboTipoAnalisisExtraccion.find((tipoAnalisisExtraccionItem) => {
          return tipoAnalisisExtraccionItem.value === this.props.tipoAnalisisPredeterminado
        })
        if (tipoAnalisisPredeterminado) {
          tipoAnalisisPredeterminado = {value: tipoAnalisisPredeterminado.value, label: this.props.t(`COMUN.COMBOS.${tipoAnalisisPredeterminado.label}`)}
          this.setState({tipoAnalisisSeleccionado: tipoAnalisisPredeterminado.value})
        }
      }
    }
    if (this.props.showModalFormSeguimiento !== prevProps.showModalFormSeguimiento && this.state.tipoAnalisisSeleccionado !== this.props.tipoAnalisisPredeterminado) {
      this.setState({tipoAnalisisSeleccionado: this.props.tipoAnalisisPredeterminado})
    }
    if (this.props.tipoControlSeleccionado !== prevProps.tipoControlSeleccionado) {
      this.setState({tipoControlSeleccionado: this.props.tipoControlSeleccionado})
    }
  }

  render () {
    const {
      t, handleSubmit, showModalFormSeguimiento, data, mainList, idAnalisis,
      actions: {openModalFormSeguimiento, openModalContajeMaquinas, closeModalFormSeguimiento},
      combos: {comboOperarioActivo, comboOperarioPredeterminado},
      auth: {versionesMagavision}
    } = this.props
    const tKey = 'SEGUIMIENTO.FORM.'
    let arrayVersionesMagavision = versionesMagavision !== null ? versionesMagavision.split(',') : []
    let comboTipoAnalisisExtraccion = []
    this.props.combos.comboTipoAnalisisExtraccion.forEach((item) => {
        if(item.value == 1 || item.value == 2){ //colorimetro, camara burker 
          comboTipoAnalisisExtraccion.push(item)
        }
        if(item.value == 7 && this.props.auth.customizations && this.props.auth.customizations.includes("Netpork")){ //Cámara neubauer
          comboTipoAnalisisExtraccion.push(item)
        }
        if(arrayVersionesMagavision.length > 0 && arrayVersionesMagavision[0] == item.value){ 
          comboTipoAnalisisExtraccion.push(item)
        }
    })
    comboTipoAnalisisExtraccion = comboTipoAnalisisExtraccion.map((tipoAnalisisExtraccionItem) => {
      return {...tipoAnalisisExtraccionItem, label: t(`COMUN.COMBOS.${tipoAnalisisExtraccionItem.label}`)}
    })


    let comboConservacion = []
    this.props.combos.comboConservacion.forEach((comboConservacionItem) => {
      comboConservacion.push(Object.assign({}, comboConservacionItem))
    })
    comboConservacion[0].predeterminado = true

    let comboTipoControlSeguimiento = this.props.combos.comboTipoControlSeguimiento
    comboTipoControlSeguimiento = comboTipoControlSeguimiento.map((tipoControlSeguimientoItem) => {
      return {...tipoControlSeguimientoItem, label: t(`COMUN.COMBOS.${tipoControlSeguimientoItem.label}`)}
    })

    let comboOperarioProcesado = comboOperarioActivo.filter(item => item.procesado===true)   

    return (
      <div>
        <SimpleModalPage/>
        <Modal show={showModalFormSeguimiento} onHide={closeModalFormSeguimiento} bsSize="large" backdrop="static">
          <form onSubmit={handleSubmit(this.guardarSeguimiento)}>
            <Modal.Header closeButton>
              <Modal.Title>{t(tKey + ((data && data.duplicarSeguimiento) ? 'TITLE_DUPLICAR' : (data && data.idSeguimiento) ? 'TITLE_MODIFICAR' : 'TITLE_NUEVO'))}</Modal.Title>
              {data && data.idSeguimiento && (
                <ButtonChangeRecord list={mainList} idElemento="idSeguimiento" currentId={data.idSeguimiento} getNextRecord={openModalFormSeguimiento} />
              )}
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Field
                  colSm={3}
                  id="codigo"
                  name="codigo"
                  controlLabel={t(tKey + 'FORM.CODIGO')}
                  component={InputText}
                  disabled={true}
                />
                <Field
                  colSm={3}
                  id="fecha"
                  name="fecha"
                  controlLabel={t(tKey + 'FORM.FECHA')}
                  component={InputDatePicker}
                />
                <Field
                  colSm={3}
                  id="tipoAnalisis"
                  name="tipoAnalisis"
                  controlLabel={t(tKey + 'FORM.TIPO_ANALISIS')}
                  component={InputSelect}
                  options={comboTipoAnalisisExtraccion}
                  valueKey="value"
                  labelKey="label"
                  onInputChange={(tipoAnalisisSeleccionado) => this.handleChangeTipoAnalisis(tipoAnalisisSeleccionado)}
                  disabled={data && data.idSeguimiento}
                />
                <Col sm={3}>
                  {
                    this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.COLORIMETRO ? (
                      <Button
                        type="button"
                        onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1) && (!data.idSeguimiento || data.duplicarSeguimiento)) && openModalContajeMaquinas(tipoAnalisisExtraccionConstants.COLORIMETRO, true) }
                        className={"btn btn-primary btn-input-style" + (((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2) || (data.idSeguimiento && !data.duplicarSeguimiento)) ? ' disabled' : '')}
                      >{t(tKey + 'BUTTONS.CONTAR')}</Button>
                    ) : this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.CAMARA_BURKER ? (
                      <Button
                        type="button"
                        onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1) && (!data.idSeguimiento || data.duplicarSeguimiento)) && openModalContajeMaquinas(tipoAnalisisExtraccionConstants.CAMARA_BURKER, true) }
                        className={"btn btn-primary btn-input-style" + (((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2) || (data.idSeguimiento && !data.duplicarSeguimiento)) ? ' disabled' : '')}
                      >{t(tKey + 'BUTTONS.CONCENTRACION_FA')}</Button>
                    ) : this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.CAMARA_NEUBAUER ? (
                      <Button
                        type="button"
                        onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1) && (!data.idSeguimiento || data.duplicarSeguimiento)) && openModalContajeMaquinas(tipoAnalisisExtraccionConstants.CAMARA_NEUBAUER, true) }
                        className={"btn btn-primary btn-input-style" + (((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2) || (data.idSeguimiento && !data.duplicarSeguimiento)) ? ' disabled' : '')}
                      >{t(tKey + 'BUTTONS.CONCENTRACION_FA')}</Button>
                    ) : (
                      this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I ||
                      this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M ||
                      this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION ||
                      this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML
                    ) && (
                      <Button
                        type="button"
                        onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1) && (!data.idSeguimiento || data.duplicarSeguimiento)) && this.abrirMagavision(this.state.tipoAnalisisSeleccionado) }
                        className={"btn btn-primary btn-input-style" + (((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2) || (data.idSeguimiento && !data.duplicarSeguimiento)) ? ' disabled' : '')}
                      >{t(tKey + 'BUTTONS.ABRIR_MAGAVISION')}</Button>
                    )
                  }
                </Col>
              </Row>
              <Row>
              {
                (
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.COLORIMETRO ||
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.CAMARA_BURKER ||
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M ||
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.CAMARA_NEUBAUER
                ) && (
                  <Field
                    colSm={3}
                    id="porMotilidad"
                    name="porMotilidad"
                    controlLabel={t(tKey + 'FORM.MOTILIDAD_PERCENT')}
                    component={InputNumerical}
                  />
                )
              }
              {
                (
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I ||
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION ||
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) && [
                  <Field
                    colSm={3}
                    id="porMotilidadTotal"
                    name="porMotilidadTotal"
                    key="porMotilidadTotal"
                    controlLabel={t(tKey + 'FORM.MOTILIDAD_TOTAL_PERCENT')}
                    component={InputNumerical}
                    disabled={true}
                  />,
                  <Field
                    colSm={3}
                    id="porMotilidadProgresiva"
                    name="porMotilidadProgresiva"
                    key="porMotilidadProgresiva"
                    controlLabel={t(tKey + 'FORM.MOTILIDAD_PROGRESIVA_PERCENT')}
                    component={InputNumerical}
                    disabled={true}
                  />
                ]
              }
              {
                (                
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) && (
                  <Field
                    colSm={3}
                    id="porMotilyNormal"
                    name="porMotilyNormal"
                    key="porMotilyNormal"
                    controlLabel={t(tKey + 'FORM.MOTILYNORMAL_PERCENT')}
                    component={InputNumerical}
                    disabled={true}
                  />
                )
              }
              {
                (                
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) && (
                  <Field
                    colSm={3}
                    id="porMotilCircular"
                    name="porMotilCircular"
                    key="porMotilCircular"
                    controlLabel={t(tKey + 'FORM.MOTILIDAD_CIRCULAR_PERCENT')}
                    component={InputNumerical}
                    disabled={true}
                  />
                )
              }
              {
                (
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M ||
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_I
                ) && (
                  <Col sm={3} smOffset={this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_M ? 6 : 3} key="getOldMagavisionResultButton">
                    <Button
                      type="button"
                      onClick={() => ((this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1) && (!data.idSeguimiento || data.duplicarSeguimiento)) && this.obtenerYGuardarResultadoSistemaAnalisisSeguimiento() }
                      className={"btn btn-primary btn-input-style" + (((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2) || (data.idSeguimiento && !data.duplicarSeguimiento)) ? ' disabled' : '')}
                    >{t(tKey + 'BUTTONS.EVALUACION')}</Button>
                  </Col>
                )
              }
                <Field
                  colSm={3}
                  id="operarioProcesado"
                  name="operarioProcesado"
                  controlLabel={t('ANALISIS_EXTRACCIONES.FORM.FORM.OPERARIO_PROCESADO')}
                  component={InputSelect}
                  options={comboOperarioPredeterminado}
                  valueKey="value"
                  labelKey="label"
                />
              </Row>
              <Row>
                <Field
                  colSm={3}
                  id="concentracion"
                  name="concentracion"
                  controlLabel={t(tKey + 'FORM.CONCENTRACION')}
                  component={InputNumerical}
                  disabled={(this.state.tipoAnalisisSeleccionado && (
                    this.state.tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.COLORIMETRO && this.state.tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.CAMARA_BURKER &&
                    this.state.tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.CAMARA_NEUBAUER
                  ))}
                />
                <Field
                  colSm={3}
                  id="calidad"
                  name="calidad"
                  controlLabel={this.state.tipoControlSeleccionado == tipoControlSeguimientoConstants.ACROSOMAS ? t('FICHA_VERRACO.NUEVO_VERRACO.H_EXTRACCIONES.MODAL.ESPERMATOZOIDES_CONTADOS') : t(tKey + 'FORM.CALIDAD')}
                  component={InputNumerical}
                  disabled={this.state.tipoControlSeleccionado == tipoControlSeguimientoConstants.ACROSOMAS}
                />
                <Field
                  colSm={3}
                  id="aglutinacion"
                  name="aglutinacion"
                  controlLabel={t(tKey + 'FORM.AGLUTINACION')}
                  component={InputNumerical}
                />
                {
                (                
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) && (
                  <Field
                    colSm={3}
                    id="aglutinacionPercent"
                    name="aglutinacionPercent"
                    controlLabel={t(tKey + 'FORM.AGLUTINACION_PERCENT')}
                    component={InputNumerical}
                  />
                )
              }
                <Field
                  colSm={3}
                  id="formasAnormales"
                  name="formasAnormales"
                  controlLabel={this.state.tipoControlSeleccionado == tipoControlSeguimientoConstants.ACROSOMAS ? t('ANALISIS_EXTRACCIONES.CONTAJE_MAQUINAS.COMUN.FORM.ACROSOMAS') : t(tKey + 'FORM.FORMAS_ANORMALES')}
                  component={InputNumerical}
                  disabled={(this.state.tipoAnalisisSeleccionado && (
                    this.state.tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.COLORIMETRO && this.state.tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.CAMARA_BURKER &&
                    this.state.tipoAnalisisSeleccionado !== tipoAnalisisExtraccionConstants.CAMARA_NEUBAUER
                  ))}
                />
              </Row>
              <Row>
                <Field
                  colSm={3}
                  id="contaminacion"
                  name="contaminacion"
                  component={InputCheckBox}
                  claseActivo="onoffswitch-label"
                  controlLabel={t(tKey + 'FORM.CONTAMINACION')}
                />
                {((data && data.idAnalisis) || idAnalisis || !!this.props.match.params.idAnalisisExtraccion) && (
                  <Field
                    colSm={3}
                    id="conservacion"
                    name="conservacion"
                    controlLabel={t(tKey + 'FORM.CONSERVACION')}
                    component={InputSelect}
                    options={comboConservacion}
                    valueKey="value"
                    labelKey="label"
                    isClearable={false}
                  />
                )}
                <Field
                  colSm={3}
                  id="tipoControl"
                  name="tipoControl"
                  controlLabel={t(tKey + 'FORM.TIPO_CONTROL')}
                  component={InputSelect}
                  options={comboTipoControlSeguimiento}
                  onInputChange={(tipoControlSeleccionado) => this.handleChangeTipoControl(tipoControlSeleccionado)}
                  valueKey="value"
                  labelKey="label"
                  disabled={data && data.idSeguimiento && this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML}
                  isClearable={false}
                />
                <Field
                  colSm={3}
                  id="empresa"
                  name="empresa"
                  controlLabel={t(tKey + 'FORM.EMPRESA')}
                  component={InputText}
                  maxLength={true}
                  valorMaxLength={100}
                />
              </Row>

              {(this.props.auth.version >= 2)  && (<Row>
                <Col sm={9}></Col>
                <Field
                    colSm={3}
                    id="apto"
                    name="apto"
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel={t('SEGUIMIENTO.COLUMNS.APTO')}
                />
              </Row>)}
              <Row>
                <Field
                  colSm={12}
                  id="observaciones"
                  name="observaciones"
                  controlLabel={t(tKey + 'FORM.OBSERVACIONES')}
                  component={InputTextArea}
                />
              </Row>
              {
                (                
                  this.state.tipoAnalisisSeleccionado === tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) && (
                  <Field
                    id="tokenAnalisisMagavision"
                    name="tokenAnalisisMagavision"
                    component="input"
                    type="hidden"
                  />
                )
              }
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                className={'btn btn-primary' + (this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2 ? ' disabled' : '')}
                disabled={(this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.SEGUIMIENTO] < 2)}
              >{t(tKey + 'BUTTONS.GUARDAR')}</Button>
              <Button type="button" className="btn btn-white" onClick={closeModalFormSeguimiento}>{t(tKey + 'BUTTONS.CERRAR')}</Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'ModalFormSeguimiento'
})(ModalFormSeguimiento))